// extracted by mini-css-extract-plugin
export default {"card":"Card_card__zQfcO","content":"Card_content__ASKh8","header":"Card_header__LgAhk"};